module.exports = __webpack_public_path__ + "static/media/htmlcssjs.99592b07.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cardicons/htmlcssjs.png
// module id = 1495
// module chunks = 0